import React from 'react';
import { footerData, navigationData } from '../data/mock';
import { Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#6b2d7b] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-[#7ed321] flex items-center justify-center text-[#2d1b38] font-bold text-xl">
                CC
              </div>
              <div>
                <h3 className="font-semibold text-lg">{footerData.company}</h3>
                <p className="text-white/60 text-sm">{footerData.tagline}</p>
              </div>
            </div>
            <p className="text-white/70 leading-relaxed max-w-md">
              Partnering with multi-family management companies and industry suppliers to optimize operations, develop talent, and drive success.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[#7ed321] hover:text-[#2d1b38] transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="mailto:Christina@ccconsulting3.com"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[#7ed321] hover:text-[#2d1b38] transition-colors"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Quick Links</h4>
            <nav className="space-y-4">
              {navigationData.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(item.href);
                  }}
                  className="block text-white/60 hover:text-[#7ed321] transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Services</h4>
            <nav className="space-y-4">
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#services');
                }}
                className="block text-white/60 hover:text-[#7ed321] transition-colors"
              >
                Consulting
              </a>
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#services');
                }}
                className="block text-white/60 hover:text-[#7ed321] transition-colors"
              >
                Training
              </a>
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#services');
                }}
                className="block text-white/60 hover:text-[#7ed321] transition-colors"
              >
                Operations Review
              </a>
              <a
                href="#services"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#services');
                }}
              className="block text-white/60 hover:text-[#7ed321] transition-colors"
              >
                Employee Development
              </a>
            </nav>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-white/50 text-sm">
                {footerData.copyright}
              </p>
              <p className="text-white/50 text-sm mt-1">
                DRE# 01347597
              </p>
            </div>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-white/50 hover:text-[#7ed321] transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-white/50 hover:text-[#7ed321] transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
